<template>
	<div class="row">
	
		<v-col class="col-12">
			<router-link to="/litters" style="text-decoration: none;">
				<v-sheet elevation="1" rounded class="text-center pa-5" >Все пометы</v-sheet>
			</router-link>
		</v-col>
		<v-col class="col-12" v-if="loading">
			<v-skeleton-loader type="article, actions" class='mb-6' boilerplate elevation="2" height="450px" width="250px">
			</v-skeleton-loader>
		</v-col>
		
		<template v-if="puppys.length >0">
			<v-card v-for="(puppy, index) in puppys" :key="index" class="mx-auto col-3 mt-4 justify-center flex" :disabled="puppy.reserved" :style="puppy.animal.sex==='F' ? 'border: 1px red solid' : 'border: 1px blue solid'">
				<v-card-title class="text-center">{{ puppy.animal.name }}</v-card-title>

				<v-card-text>
				<v-img :src="puppy.animal.url" height="250" width="250"></v-img>
				Дата рождения: {{ puppy.animal.birthday }}<br>
				Окрас: {{ puppy.animal.color }}<br>
				Пол: {{ puppy.animal.sex=='F' ? "Female" : "Male" }}
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn outlined :href="`mailto:catahoulakennel@gmail.com?subject=${puppy.animal.name}`" >Зарезервировать</v-btn>
					<v-spacer></v-spacer>
				</v-card-actions>
			</v-card>
		</template>
		<template v-else>
			<div class="card mb-4 box-shadow p-2 w-100" >
				К сожалению, в настоящее время, отсутсвуют щеники на продажу.
			</div>
		</template>
	</div>

	<!--
		<v-card v-for="(puppy, index) in puppys" :key="index">
				<div class="card mb-4 box-shadow p-2" :class="[puppy.animal.sex==='F' ? 'border-danger' : 'border-primary']" >
					<div class="card-header">
						<h4 class="my-0 font-weight-normal">{{ puppy.animal.name }}</h4>
					</div>
					<img class="card-img-top img-fluid img-thumbnail" :src="puppy.animal.url" :alt="puppy.animal.name">
					<div class="card-body">
						<ul class="list-unstyled mt-3 mb-4 text-left">
							<li>{{ puppy.animal.birthday }}</li>
							<li>{{ puppy.animal.color }}</li>
							<li>{{ puppy.animal.sex=='F' ? "Female" : "Male" }}</li>
						</ul>
					</div>
					<a class="btn btn-lg btn-block btn-outline-primary" :class="[puppy.reserved ? 'disabled': '']" href="mailto:catahoulakennel@gmail.com?subject={{ puppy.animal.name }}&mess='Reserved puppy {{ pupppy.animal.name }}'">Make a reservation</a>
				</div>
			</v-card>
		-->
</template>

<script>
import axios from 'axios'

export default {
	name: 'Puppy',
	data() {
		return {
			puppys: [],
			loading: true,
		}
	},
	methods: {
		getPuppyInfo() {
			var url = 'http://catahoulakennel.ru/api/v1/pedigree/puppy?sale'
			axios.get(url)
			.then(response => { this.puppys = response['data']; this.loading = false})
		}
	},
	beforeMount() {
		this.getPuppyInfo()
	}
}
</script>

<style>
.card-img-top {
	width: 200px;
}
.card-body {
	height: 140px;
}
.disabled {
	pointer-events: none;
	cursor: default;
}
</style>